//elementos de antDesing
import Vue from 'vue'

import 'ant-design-vue/dist/antd.css'
import Layout from 'ant-design-vue/lib/layout'
import LayoutContent from 'ant-design-vue/lib/layout'
import Calendar from 'ant-design-vue/lib/calendar'
import Badge from 'ant-design-vue/lib/badge'
import Modal from 'ant-design-vue/lib/modal'
import Button from 'ant-design-vue/lib/button'
import ConfigProvider from 'ant-design-vue/lib/config-provider'
import Notification from 'ant-design-vue/lib/notification'
import TimePicker from 'ant-design-vue/lib/time-picker'
import DatePicker from 'ant-design-vue/lib/date-picker'
import Card from 'ant-design-vue/lib/card'
import Icon  from 'ant-design-vue/lib/icon'
import Input  from 'ant-design-vue/lib/input'

Vue.component('antLayout', Layout)
Vue.component('antLayoutContent', LayoutContent)
Vue.component('antCalendar', Calendar)
Vue.component('antBadge', Badge)
Vue.component('antModal', Modal)
Vue.component('antButton', Button)
Vue.component('antConfigProvider', ConfigProvider)
Vue.component('antNotification', Notification)
Vue.component('antTimePicker', TimePicker)
Vue.component('antDatePicker', DatePicker)
Vue.component('antCard', Card)
Vue.component('antIcon', Icon)
Vue.component('antInput', Input)